import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import EditSvg from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'molecules/Grid/Grid';
import { openModal } from 'store/layoutSlice';
import { fetchCategories, removeCategory, selectCategories, selectCategoriesErrors, selectCategoriesPageInfo, selectCategoriesRefetchFlags, selectCategoriesStatus, } from 'store/parameters/categoriesSlice';
import ParametersTable from '../shared/ParametersTable';
function Categories() {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const categories = useSelector(selectCategories);
    const pageInfo = useSelector(selectCategoriesPageInfo);
    const status = useSelector(selectCategoriesStatus);
    const errors = useSelector(selectCategoriesErrors);
    const refetchFlags = useSelector(selectCategoriesRefetchFlags);
    const fetchMore = () => {
        if (pageInfo.hasNextPage && status.fetch !== 'loading') {
            dispatch(fetchCategories());
        }
    };
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchCategories());
        }
    }, [dispatch, status.fetch, refetchFlags.fetch]);
    const handleDelete = (categoryId) => {
        dispatch(removeCategory(categoryId));
    };
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    const hasCategories = categories.length > 0;
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } },
            React.createElement(Button, { color: "primary", onClick: () => dispatch(openModal({ name: 'categoryCreator' })) }, t('add_category'))),
        hasCategories ? (React.createElement(ParametersTable, { columns: [
                ['320px', '1fr'],
                ['72px', 'auto'],
            ], headers: [{ content: t('common:name') }, { content: null }], dataLength: categories.length, hasMore: pageInfo.hasNextPage, fetchMore: fetchMore }, categories.map((category) => (React.createElement(Row, { key: category.id },
            React.createElement(Cell, null, category.name),
            React.createElement(Cell, null, ((category === null || category === void 0 ? void 0 : category.canNameBeUpdated) || (category === null || category === void 0 ? void 0 : category.canBeRemoved)) && (React.createElement(Dropdown, null,
                (category === null || category === void 0 ? void 0 : category.canNameBeUpdated) && (React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: () => dispatch(openModal({ name: 'categoryEditor', id: category.id })) }, t('common:edit'))),
                (category === null || category === void 0 ? void 0 : category.canBeRemoved) && (React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => handleDelete(category.id) }, t('common:delete'))))))))))) : (React.createElement(EmptyState, null))));
}
export default memo(Categories);
